// extracted by mini-css-extract-plugin
module.exports = {"fixed-background":"_2cb7bf211f7df5b9b91de76bb7ec5709-less","fixedBackground":"_2cb7bf211f7df5b9b91de76bb7ec5709-less"};